import React from 'react';
import { useDispatch } from 'react-redux';

// Import actions
import { fetchPassCover } from 'store/actions';

// Import helpers
import {
	IMAGE_SIZE_INFO,
	PRODUCT_IMAGES_REQUIREMENTS
} from 'components/helpers/info_helpers/info_texts';

// Import components
import Image from 'components/utilities/images/Image';
import InfoTitleCollapse from 'components/utilities/info/InfoTitleCollapse';

// Import translation
import { useTranslation } from 'react-i18next';

const PassesImages = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	return (
		<>
			<InfoTitleCollapse
				title={IMAGE_SIZE_INFO}
				requirements={PRODUCT_IMAGES_REQUIREMENTS}
			/>
			<Image
				title={t('common:images.cover')}
				fetchResourcesAction={(id) => fetchPassCover(id)(dispatch)}
				collectionType="cover"
				mediaType="pass"
				storePathSelector="passes"
				productSubtype="passes"
			/>
		</>
	);
};

export default PassesImages;
